import {
  IMPERSONATION_RESET,
  IMPERSONATION_SET_IMPERSONATOR,
  IMPERSONATION_SET_TIMED_OUT,
  IMPERSONATION_SET_TIMING_OUT,
} from "src/redux/actions";

export interface ImpersonationStateI {
  isImpersonating: string;
  isTimingOut: boolean;
  isTimedOut: boolean;
}

const initialState = {
  isImpersonating: null,
  isTimingOut: false,
  isTimedOut: false,
};

type ImpersonationSetImpersonatorI = {
  type: typeof IMPERSONATION_SET_IMPERSONATOR;
  impersonator: string;
};

type ImpersonationSetTimingOutI = {
  type: typeof IMPERSONATION_SET_TIMING_OUT;
  isTimingOut: boolean;
};

type ImpersonationSetTimedOutI = {
  type: typeof IMPERSONATION_SET_TIMED_OUT;
  isTimedOut: boolean;
};

type ImpersonationResetI = {
  type: typeof IMPERSONATION_RESET;
};

export type ImpersonationAction =
  | ImpersonationSetImpersonatorI
  | ImpersonationSetTimedOutI
  | ImpersonationSetTimingOutI
  | ImpersonationResetI;

const impersonation = (
  state: ImpersonationStateI = initialState,
  action: ImpersonationAction
): ImpersonationStateI => {
  switch (action.type) {
    case IMPERSONATION_SET_IMPERSONATOR:
      return {
        ...state,
        isImpersonating: action.impersonator,
      };
    case IMPERSONATION_SET_TIMING_OUT:
      return {
        ...state,
        isTimingOut: action.isTimingOut,
      };
    case IMPERSONATION_SET_TIMED_OUT:
      return {
        ...state,
        isTimedOut: action.isTimedOut,
      };
    case IMPERSONATION_RESET:
      return initialState;
    default:
      return state;
  }
};

export default impersonation;
